export const getUserLoading = state => state.userAuthReducer.userLoading;
export const getUser = state => state.userAuthReducer.user;
export const getAuthError = state => state.userAuthReducer.error;
